<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>

  <div v-else>
    <div class="ui one columns stackable grid">
      <!-- <div class="column"></div> -->
      <!-- <div class="column">
      </div> -->
      <div class="right aligned column" style="">
        <div class="ui blue labeled icon tiny button"
             style="background-color: #135c93;"
             @click="showModal(true)"
             v-if="isAdmin() && useInventory"
        >
          <i class="plus icon"></i>
          Add Package For Item Categories
        </div>
        <div class="ui blue labeled icon tiny button"
             style="background-color: #135c93;"
             @click="showModal(false)"
             v-if="isAdmin()"
        >
          <i class="plus icon"></i>
          Add Package For Reservations
        </div>
      </div>
    </div>
    <abstractTable :columns="packageColumns"
                   :data="computedPackage"
                   :classes="'ui tablet very compact center aligned celled sortable table'"
                   :dataPerPage="20" :paginationEnable="true"
                   :paginationNextButtonText="$t('next')"
                   :paginationPervButtonText="$t('previous')"
                   :paginationFirstPageButtonText="$t('first')"
                   :paginationLastPageButtonText="$t('last')">
        <template slot="table-column">
          <th class="no-print" style="width: 14%"> {{ $t('actions') }} </th>
        </template>
      <template slot="table-row-after" slot-scope="props">
          <td class="no-print">
            <div class="ui blue tiny very compact button"
                 :data-tooltip="`${$t('show') + ' ' + $t('reservation')}`"
                 style="background-color: #092442"
                 @click="finishPackage(props.row.id)">
              <!-- <i class="file icon"></i> -->
              Finish now
            </div>
          </td>
        </template>
    </abstractTable>


    <div class="ui large longer modal" id="package" style="margin-top: 20px !important;">
      <div class="header">New Package</div>
        <newPackage
          :object="packages"
          :package="newPackage"
          :forItemCategory="forItemCategory"
          :itemCategories="itemCategories"
          :isNotValidForm="isNotValidForm"
        />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    newPackage: require('@/components/clinics/clinic_components/packages/NewBigPackage').default
  },
  data () {
    return {
      actionName: '',
      packages: [],
      medicalMachines: [],
      items: [],
      itemCategories: [],
      newPackage: {
        name: '',
        unit_price: null,
        description: '',
        quantity: null,
        started_at: null,
        finished_at: null,
        unit_measurement_id: null,
        item_category_id: null,
        medicalMachines: [],
        items: [],
        entities: []
      },
      forItemCategory: false,
      loading: true,
      isNotValidForm: true
    }
  },
  mounted () {
    this.axios.all([this.getgroupedPackages(), this.getItemCategories()])
      .then(this.axios.spread((groupedPackagesResponse, itemCategoriesResponse) => {
        this.packages = groupedPackagesResponse.data
        // this.medicalMachines = medicalMachinesResponse.data
        // this.items = itemsResponse.data
        this.itemCategories = itemCategoriesResponse.data
        this.loading = false
      }))
  },
  computed: {
    useInventory() {
      return this.permissions.invetory_permissions.used
    },
    packageColumns () {
      return [
        { header: 'Id', fieldName: 'id', show: false},
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Description', fieldName: 'description', show: true },
        { header: 'Price', fieldName: 'unit_price', show: true },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Started At', fieldName: 'started_at', show: true },
        { header: 'Finished At', fieldName: 'finished_at', show: true }
      ]
    },
    computedPackage () {
      let formlatedPackages = []

      window._.each(this.packages, selectedpackage => {
        formlatedPackages.push({
          id: selectedpackage.id,
          name: selectedpackage.name || '-',
          description: selectedpackage.description || '-',
          unit_price: this.formatPrice(selectedpackage.unit_price),
          quantity: selectedpackage.quantity || '-',
          started_at: selectedpackage.started_at ?
            window.moment(selectedpackage.started_at).format('DD/MM/YYYY - hh:mm a') : '-',
          finished_at: selectedpackage.finished_at
            ? window.moment(selectedpackage.finished_at).format('DD/MM/YYYY - hh:mm a') : '-'
        })
      })

      return formlatedPackages.sort((a, b) => b.id - a.id)
    }
  },
  methods: {
    getgroupedPackages () {
      return this.$http.get('packages/available', { params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      } })
    },
    getMedicalMachines () {
      return this.$http.get('medical_machines', { params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      } })
    },
    getItemCategories () {
      return this.$http.get('items/categories')
    },
    initPackage () {
      this.newPackage = {
        name: '',
        unit_price: null,
        description: '',
        quantity: null,
        started_at: null,
        finished_at: null,
        unit_measurement_id: null,
        item_category_id: null,
        medicalMachines: [],
        items: [],
        entities: []
      }

      this.isNotValidForm = true
    },
    showModal (wantItemCategoryPackage) {
      this.forItemCategory = wantItemCategoryPackage
      $('#package').modal({
        onHidden: () => {
          this.initPackage()
        }
      }).modal('show').modal('refresh')
      this.initGUI()
    },
    initGUI () {
      this.$nextTick(() => {
        $('#start-at').calendar({
          type: 'datetime',
          minDate: new Date(),
          onChange: (date) => {
            this.newPackage.started_at = date
          }
        })

        $('#finish-at').calendar({
          type: 'datetime',
          minDate: this.newPackage.start_at,
          onChange: (date) => {
            this.newPackage.finished_at = date
          }
        })

        $('#item-packages-multi-select').dropdown()
        $('#medical-machine-packages-multi-select').dropdown()

        // if (this.forItemCategory) {
          $('#unit-measurement-search').dropdown()
          $('#item-category-search').dropdown()
        // }

        if (!this.forItemCategory) {
          $('#new-default-package-step').form({
            inline: true,
            on: 'blur',
            fields: {
              name: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please enter package name.'
                  }
                ]
              },
              quantity: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please enter the quantity.'
                  },
                  {
                    type: 'number',
                    prompt: 'Please enter valid quantity.'
                  }
                ]
              },
              unitPrice: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please enter the unit price.'
                  },
                  {
                    type: 'number',
                    prompt: 'Please enter valid unit price.'
                  }
                ]
              }
            }
          })    
        }
        if (this.forItemCategory) {
          $('#new-default-package-step').form({
            inline: true,
            on: 'blur',
            fields: {
              name: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please enter package name.'
                  }
                ]
              },
              quantity: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please enter the quantity.'
                  },
                  {
                    type: 'number',
                    prompt: 'Please enter valid quantity.'
                  }
                ]
              },
              unitPrice: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please enter the unit price.'
                  },
                  {
                    type: 'number',
                    prompt: 'Please enter valid unit price.'
                  }
                ]
              },
              itemCategory: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please choose item category.'
                  },
                  {
                    type: 'integer',
                    prompt: 'Please Choose valid option.'
                  }
                ]
              },
              unitMeasurement: {
                rules: [
                  {
                    type: 'empty',
                    prompt: 'Please choose unit measurment.'
                  },
                  {
                    type: 'integer',
                    prompt: 'Please Choose valid option.'
                  }
                ]
              }
            }
          })
        }
      })
    },
    finishPackage (packageId) {
      this.$http.post(`packages/${packageId}/finish`, {
        clinic_id: this.getFromLocalStorage('clinicId')
      }).then(() => {
        let removedPackageIndex = window._.findIndex(this.packages, selectedpackage => {
          return selectedpackage.id === packageId
        }) 
        if (removedPackageIndex != null && removedPackageIndex > -1) {
          this.packages.splice(removedPackageIndex, 1);
        }

        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/clinics/clinic_components/packages/Packages.vue